module.exports = __webpack_public_path__ + "img/logout.c49b0818.svg";